<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="中文名称">
              <a-input placeholder="请输入中文名称" v-model="queryParam.appCnName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button @click="batchDel" v-if="selectedRowKeys.length > 0" ghost type="primary" icon="delete"
        >批量删除
      </a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <SysInfo-modal ref="modalForm" @ok="modalFormOk"></SysInfo-modal>
  </a-card>
</template>
<script>
import SysInfoModal from './modules/SysInfoModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JDictSelectTag from '@/components/dict/JDictSelectTag'

export default {
  name: 'SysInfoList',
  mixins: [JeecgListMixin],
  components: {
    SysInfoModal,
    JDictSelectTag
  },
  data() {
    return {
      description: '系统应用管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: 'AppId',
          align: 'center',
          dataIndex: 'appId'
        },
        {
          title: '英文名称',
          align: 'center',
          dataIndex: 'appEnName'
        },
        {
          title: '中文名称',
          align: 'center',
          dataIndex: 'appCnName'
        },
        {
          title: '系统描述',
          align: 'center',
          dataIndex: 'appDesc'
        },
        {
          title: '首页地址',
          align: 'center',
          dataIndex: 'indexPage'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/atlxsysinfo/list',
        delete: '/api/atlxsysinfo/delete',
        deleteBatch: '/api/atlxsysinfo/deleteBatch'
      }
    }
  },
  computed: {}
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
